import addMonths from 'date-fns/addMonths';
import formatter from 'date-fns/format';
import isFuture from 'date-fns/isFuture';
import type { IDateService } from 'v2/interfaces/date';

class DateService implements IDateService {
  public isFutureDate(date: Date): boolean {
    return isFuture(date);
  }

  public stringToDate(stringDate: string): Date {
    return new Date(stringDate);
  }

  public dateToString(date: Date, format = 'yyyy-MM-dd'): string {
    return formatter(date, format);
  }

  public addMonths(date: Date, months: number): Date {
    return addMonths(date, months);
  }
}

export const dateService = new DateService();
